import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Col, Form, Media, Image, Row, Card, Button, Badge } from "react-bootstrap";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import {
  fetchEventsStart
} from "../../store/actions/EventAction";
import "./EventPageIndex.css";
import moment from "moment";

import LandingLayout from "../LandingPages/LandingLayout";

const EventPageIndex = (props) => {
  const isLoggedIn = !!localStorage.getItem("userId");

  useEffect(() => {
    props.dispatch(fetchEventsStart());
  }, []);

  if (!isLoggedIn) {
    return (
      <LandingLayout title="Upcoming Events | Rebel">
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="breadcrumbs">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Events</span>
            </div>

            <p className="page-label">LIVE EXPERIENCES</p>
            <h1>Upcoming Events</h1>
            <p className="hero-description">
              Discover live shows, exclusive creator meetups, and tickets across The Bahamas.
            </p>
          </div>
        </section>

        <section className="events-section">
          {props.events.loading ? (
            <div className="text-center py-5" style={{ color: "#d9a6ff", fontSize: "1.2rem" }}>
              {t("loading")}
            </div>
          ) : props.events.data.length > 0 ? (
            <div className="landing-events-grid">
              {props.events.data.map((event) => (
                <Link to={"/event/" + event.id} key={event.id} style={{ textDecoration: "none" }}>
                  <article className="landing-event-card">
                    <div className="card-img-wrapper">
                      <img src={event.event_image} alt={event.title} />
                    </div>
                    <div className="card-body-content">
                      <h3 className="event-title">{event.title}</h3>
                      <div className="event-meta-info">
                        <div className="meta-item">
                          <i className="fas fa-calendar-alt" />
                          <span>
                            {moment(event.start_datetime).format("ddd, MMM DD YYYY")} | {moment(event.start_datetime).format("h:mm A")}
                          </span>
                        </div>
                        <div className="meta-item">
                          <i className="fas fa-map-marker-alt" />
                          <span>{event.venue}</span>
                        </div>
                      </div>
                      <div className="card-bottom-row">
                        <span className="category-pill">{event.event_category}</span>
                        <span className="price-tag">${event.ticket_price}</span>
                      </div>
                    </div>
                  </article>
                </Link>
              ))}
            </div>
          ) : (
            <div
              className="text-center py-5"
              style={{
                background: "rgba(255,255,255,0.03)",
                borderRadius: "16px",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#b9b6cb",
              }}
            >
              <h3>{t("no_upcoming_events")}</h3>
            </div>
          )}
        </section>
      </LandingLayout>
    );
  }

  return (
    <>
      <div className="notification-page">
        <Container>
          <div className="profile-post-area">
            <div className="bookmarkes-list bookmarks-right-side resp-sapce-center">
              <div className="pull-left">
                <Link className="bookmarkes-list notify-title" to={`/home`}>
                  <Image
                    src="/assets/images/icons/back.svg"
                    className="svg-clone mr-2"
                  />

                  {t("upcoming_events")}
                </Link>
              </div>
            </div>
          </div>
          <Row>
            {props.events.loading
              ?
              (<Col md={12} sm={12} lg={12} xl={12}>
                {t("loading")}
              </Col>
              ) : (props.events.data.length > 0)
                ? props.events.data.map((event) => (
                  <Col key={event.id} md={4} className="mb-5">
                    <Link to={"event/" + event.id} >
                      <Card className="card event-card h-450px">
                        <div className="card-img-wrapper">
                          <Card.Img variant="top" src={event.event_image} />
                        </div>
                        <Card.Body>
                          <Card.Title className="event-title">{event.title}</Card.Title>
                          {/* Date & Location with icons */}
                          <div className="event-meta mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <i className="fas fa-calendar-alt text-dark mr-3" />
                              <span className="meta-text">{moment(event.start_datetime).format("ddd, MMM DD YYYY") + " | " + moment(event.start_datetime).format("h:mm A")}</span>
                            </div>
                            <div className="d-flex align-items-start">
                              <i className="fas fa-map-marker-alt text-dark mr-3 mt-1" />
                              <span className="meta-text">{event.venue}</span>
                            </div>
                          </div>
                          {/* <Card.Text className="event-desc">{event.description}</Card.Text> */}
                          {/* Category + Price */}
                          <div className="justify-content-between d-flex">
                            <Badge pill variant="info" className="badge-category">
                              {event.event_category}
                            </Badge>
                            <span className="event-price">{"$" + event.ticket_price}</span>
                          </div>

                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                )) :
                <Col md={12} sm={12} lg={12} xl={12}>
                  <Card className="event-detail-card mb-5">
                    <Card.Body>
                      {t("no_upcoming_events")}
                    </Card.Body>
                  </Card>
                </Col>
            }
          </Row>
        </Container>
      </div>
    </>
  );
};

const mapStateToPros = (state) => ({
  events: state.event.events,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(EventPageIndex));
